import React from 'react';

import { RestrictionsButtonPlaceholder } from './RestrictionsButtonPlaceholder.tsx';

export const RestrictionsButtonLoading = (): React.JSX.Element => {
	return <RestrictionsButtonPlaceholder />;
};
